import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CheckBoxModule, RadioButtonModule, TextAreaModule } from '@progress/kendo-angular-inputs';
import { IconComponent } from '../../ui/icon/icon.component';
import { NgClass, NgIf } from '@angular/common';
import { SharedModule } from '@progress/kendo-angular-dropdowns';
import { TranslatePipe } from '../../../pipes/translate/translate.pipe';
import { CollectionFormValidatorResult } from '../../../../features/bizzmine/form/classes/collection-form-validator-result';
import { formsActions } from 'src/app/store/features/forms/forms-actions';
import { Store } from '@ngrx/store';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

@Component({
  selector: 'bizz-validation-summary',
  templateUrl: './validation-summary.component.html',
  styleUrls: ['./validation-summary.component.scss'],
  imports: [
    CheckBoxModule,
    IconComponent,
    RadioButtonModule,
    SharedModule,
    TextAreaModule,
    TranslatePipe,
    NgClass
  ],
  standalone: true,
})
export class ValidationSummaryComponent {
  @Input() public validation: CollectionFormValidatorResult | undefined;
  @Output() public validationLinkClick = new EventEmitter<number>();
  public aiFieldsValidationHidden = true;

  public constructor(
    private store$: Store) {
  }

  public setAiButtonAllAcceptance(): void {
    this.store$.dispatch(formsActions.acceptAllAiGeneration({
      formId: this.validation?.FormId ?? '',
    }));
    this.store$.dispatch(formsActions.clearFormValidation({
      formId: this.validation?.FormId ?? ''
    }));
  }

  protected readonly Math = Math;
}
